export const hashtag_data_by_category: Record<string, string[]> = {
    modeling: ['아이템/도구', '가구', '커스텀블럭'],
    architecture: ['스폰/허브', '던전', '맵', '스키마틱'],
    entity: ['보스', '몹/동물', '펫', '탈것', '상자'],
    pixel: ['채팅관련', '아이콘', '스프라이트', '인게임 GUI', 'HUD', '쉐이더', '스킨'],
    free: ['무료'],
    scripts: ['스크립트'],
    skins: ['스킨'],
    skills: ['스킬'],
    plugins: ['플러그인'],
};
